import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import useModal, { MODAL_LG } from '../../../theme/Component/hooks/useModal';
import { _StructureCatalog } from '../../../../core/services/dataBean/EntityCatalogVdos';
import { BasicTable, MASK_NUMBER } from '../../../theme/Component/BasicTable';
import { Modal } from '../../../theme/Component/Modal';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const HealthIDStructureSelect = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {

    const { instance, lista, setLista } = useDataBean(_StructureCatalog)
    const [id, setID] = useState(null);

    const modal = useModal("Estructura", MODAL_LG);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDHealthIDStructure == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };


    const getLista = () => {

        instance.getHealthIDStructureCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    console.log();

                    setLista(resp)
                }
            }
        ).catch(err => { console.log(err) })
    }
    const head = [
        { title: 'ID', property: 'IDHealthIDStructure', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Formato Genérico del Código', property: 'CodeFormat', visible: true },
        { title: 'Formato Rubro Presupuestal', property: 'ViewCodeFormat', visible: true },
        { title: 'Separador de Código', property: 'CodeSeparator', visible: true },
        { title: 'País', property: 'Country', visible: true },
    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Estructura"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDHealthIDStructure); modal.close(); }}></BasicTable>
            </Modal>
        </>
    )
}